import * as React from 'react';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { Button } from 'reactstrap';
import { createCalendar } from '../../api/calendar-api';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import { updateCalendarList } from '../../../calendar/api/calendar-api';
import {
  test,
  publishCalendarLink,
  unpublishCalendarLink2,
  invitedUsers,
  searchUsers
} from '../../../calendar/api/calendar-api';
import { Acl } from './acl/acl';
import { Acl2 } from './acl/acl2';
import i18n from 'i18next';
import Spinner from '../../../components/spinner/spinner';
import '../../../app.scss';

export class Calendars extends React.Component {
  constructor(props) {
    super(props);
    this.position = { X: 'Right', Y: 'Top' };
    this.onAddClick = this.onAddClick.bind(this);
    this.onModifyClick = this.onModifyClick.bind(this);
    this.onTestClick = this.onTestClick.bind(this);
    this.onPublishCalendarLink = this.onPublishCalendarLink.bind(this);
    this.onUnpublishCalendarLink = this.onUnpublishCalendarLink.bind(this);
    this.onShareSwitch = this.onShareSwitch.bind(this);
    this.onChangeShareList = this.onChangeShareList.bind(this);
    this.aclViewListInstance = null;
    this.calInvitedPeople = [];
    this.contacts = [];

    this.state = {
      errorName: '',
      calendarid: this.props.calendarId,
      hideAddCalendarButton: false,
      color: '',
      shareCalendar: false,
      calendarName: '',
      calendarDescription: '',
      showCalLink: false,
      showCalContacts: false,
      showAccessConfig: false,
      nameValue: '',
      loading: false,
      disabled: false
    };

    this.toasts = [
      {
        content: i18n.t('schedule.toast-processing'),
        cssClass: 'e-toast-black',
        icon: ''
      },
      {
        content: i18n.t('schedule.toast-process-complete'),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      },
      {
        content: i18n.t('schedule.toast-process-error'),
        cssClass: 'e-toast-danger',
        icon: 'lf-icon lf-icon-close-round'
      },
      {
        content: i18n.t('schedule.toast-create-calendar-complete'),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      },
      {
        content: i18n.t('schedule.toast-edit-calendar-complete'),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      }
    ];
  }

  toastCusAnimation = {
    hide: { duration: '1' },
    show: { duration: '200' }
  };

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  onAddClick() {
    this.setState({ errorName: '' });

    if (this.nameObj && this.nameObj.value !== null) {
      this.setState({ buttonDisabled: true });
      const { userId, userAccount, lexonToken } = this.props;

      const color = this.getRandomColor();

      const calendar = {
        summary: this.nameObj.value,
        description: this.descriptionObj.value,
        color: color
      };
      this.setState({ loading: true });
      createCalendar(calendar, userId, userAccount, lexonToken)
        .then(() => {
          this.toastObj.hide('All');
          this.setState({ loading: false });
          this.toastObj.show(this.toasts[3]);
          this.setState({ buttonDisabled: false });
          this.props.successCalendarClose('add');
        })
        .catch(error => {
          const message = error.message.split('code')[1];
          const codeError = message.split('-')[0];
          this.setState({ loading: false });
          this.toastObj.hide('All');

          if (parseInt(codeError, 10) === 405) {
            this.toastObj.show(this.toasts[3]);
          } else {
            this.toastObj.show(this.toasts[2]);
          }

          this.addBtn.properties.disabled = false;
          this.setState({ buttonDisabled: false });
        });
    }
  }

  onModifyClick() {
    const { userId, userAccount, lexonToken } = this.props;

    const calendarData = {
      summary: this.nameObj.value,
      description: this.descriptionObj.value,
      backgroundColor: this.state.color
    };

    if (this.nameObj.value == undefined || this.nameObj.value === '') {
      this.setState({ errorName: 'Dato obligatorio' });
      return;
    }

    this.setState({ errorName: '' });

    this.setState({ loading: true });
    updateCalendarList(this.props.calendarId, calendarData, userId, userAccount, lexonToken)
      .then(() => {
        this.toastObj.hide('All');
        this.setState({ loading: false });
        this.toastObj.show(this.toasts[4]);
        this.setState({ buttonDisabled: false });
        this.props.successCalendarClose('edit');
      })
      .catch(() => {
        this.setState({ loading: false });
        this.toastObj.hide('All');
        this.toastObj.show(this.toasts[2]);
        this.addBtn.properties.disabled = false;
        this.setState({ buttonDisabled: false });
      });
  }

  onTestClick() {
    const { userId, userAccount, lexonToken } = this.props;

    const calendarData = {
      summary: this.nameObj.value,
      description: this.descriptionObj.value,
      backgroundColor: this.state.color
    };

    test(this.props.calendarId, calendarData, userId, userAccount, lexonToken).then(res => {
      console.info(res);
    });
  }

  onPublishCalendarLink() {
    const { userId, userAccount, lexonToken } = this.props;

    const calendarData = {
      summary: this.nameObj.value,
      description: this.descriptionObj.value,
      backgroundColor: this.state.color
    };
    publishCalendarLink(this.props.calendarId, calendarData, userId, userAccount, lexonToken).then(() => {});
  }

  onUnpublishCalendarLink() {}

  onShareSwitch(args) {
    if (args.checked) {
      this.setState({
        hideAddCalendarButton: true,
        shareCalendar: true,
        showCalLink: true
      });
    } else {
      this.setState({
        hideAddCalendarButton: false,
        shareCalendar: false,
        showCalLink: false
      });
      const { userId, userAccount, lexonToken } = this.props;

      this.setState({ loading: true });

      unpublishCalendarLink2(this.props.calendarId, userId, userAccount, lexonToken)
        .then(() => {
          this.toastObj.hide('All');
          this.setState({ loading: false });
          this.toastObj.show(this.toasts[1]);
        })
        .catch(() => {
          this.toastObj.hide('All');
          this.setState({ loading: false });
          this.toastObj.show(this.toasts[2]);
        });
    }
  }

  onChangeShareList(args) {
    this.aclViewListInstance = args;
  }

  onDataBinding(items) {
    let updateState = false;
    // Resetear el array antes de cargar nuevos datos para evitar duplicados
    this.calInvitedPeople = [];
    if (items.length > 0) {
      const users = items[0].user;
      if (users && users.length > 0) {
        users.forEach(user => {
          // Extraer el email del href (formato: principal:principals/users/EMAIL)
          const userEmail = user.href && user.href[0] 
            ? user.href[0].replace('principal:principals/users/', '')
            : user['common-name'][0];
          
          if (userEmail === this.props.userAccount) {
            updateState = true;
          }
          this.calInvitedPeople.push({
            text: user['common-name'][0],
            id: `user:${userEmail}`,
            role: Object.keys(user.access[0])[0],
            icon: 'delete-icon'
          });
        });
      }
    }
    if (updateState) {
      this.setState({
        shareCalendar: true,
        showCalLink: true,
        showAccessConfig: true
      });
    } else {
      this.setState({ showAccessConfig: true });
    }
  }

  onContactsDataBinding(items) {
    // Resetear el array antes de cargar nuevos datos para evitar duplicados
    this.contacts = [];
    if (items && items.data && items.data.length > 0) {
      items.data.forEach(user => {
        if (user.id !== this.props.userAccount) {
          this.contacts.push({
            text: user.id
          });
        }
      });
    }
    this.setState({ showCalContacts: true });
  }

  setCalendarTitleDisabledState = () => {
    const calendar = this.props.calendars.find(
      a => a.id === this.props.calendarId
    );

    if (!calendar) {
      this.setState({ disabled: false });
      return;
    }

    const splitId = calendar.id.split('/');
    const calendarId = splitId[splitId.length - 2];

    const isPersonalCalendarOwner =
      calendarId === 'personal' && calendar.accessRole === 'owner';

    this.setState({ disabled: isPersonalCalendarOwner });
  };

  async componentDidMount() {
    this.setCalendarTitleDisabledState();

    if (this.props.calendarId != '') {
      const calendar = this.props.calendars.find(
        a => a.id === this.props.calendarId
      );
      this.nameObj.value = calendar.summary;
      this.setState({ nameValue: calendar.summary });
      if (calendar.description) {
        this.descriptionObj.value =
          calendar.description !== 'undefined' &&
          calendar.description !== 'null'
            ? calendar.description
            : '';
        document.getElementById(
          'description-length'
        ).textContent = `${calendar.description.length}/3000`;
      }
      this.setState({
        color: calendar.backgroundColor,
        calendarName: this.nameObj.value,
        calendarDescription: this.descriptionObj.value
      });

      invitedUsers(
        this.state.calendarid,
        this.props.userId,
        this.props.userAccount,
        this.props.lexonToken
      )
        .then(result => {
          this.onDataBinding(result.responses[0].data.invite);
        })
        .catch(error => {
          console.error('error ->', error);
        });

       try {
        const contacts = await searchUsers(this.props.userNavision, this.props.token);
        this.onContactsDataBinding(contacts);
      } catch (err) {
        this.setState({ showCalContacts: true });
        console.error('error ->', err);
      }
    }
    document.getElementById('description-length').textContent = `${0}/3000`;
  }

  onInput = () => {
    this.descriptionObj.addAttributes({ maxlength: 3000 });
    const descriptionCount = this.descriptionObj.respectiveElement.value;
    document.getElementById(
      'description-length'
    ).textContent = `${descriptionCount.length}/3000`;
  };

  render() {
    let ObjClick;
    let ObjText;
    let ObjClickTest;
    let ObjTextTest;
    let ObjClick_PublishCalendarLink;
    let ObjText_PublishCalendarLink;
    let ObjClick_UnpublishCalendarLink;
    let ObjText_UnpublishCalendarLink;
    let ObjSwitch;

    const calendarData = {
      summary: this.state.calendarName,
      description: this.state.calendarDescription
    };

    if (this.props.calendarId != '') {
      ObjClick = this.onModifyClick;
      ObjText = i18n.t('general.save');
      ObjClickTest = this.onTestClick;
      ObjTextTest = 'test';
      ObjClick_PublishCalendarLink = this.onPublishCalendarLink;
      ObjText_PublishCalendarLink = 'publicar';
      ObjClick_UnpublishCalendarLink = this.onUnpublishCalendarLink;
      ObjText_UnpublishCalendarLink = 'privado';
      ObjSwitch = this.onShareSwitch;
    } else {
      ObjClick = this.onAddClick;
      ObjText = i18n.t('general.create');
    }

    return (
      <React.Fragment>
        <Spinner
          visible={this.state.loading}
          className="spinner-calendar"
          pathClassName={`spinnerPath`}
        />
        <div
          id="calendars-containers"
          className="custom-margin custom-padding-5 material2"
        > 
          <div id="formComponents">
            <div className="d-flex justify-content-end mt-4">
              <span className="inter-semibold-16 text-required">*</span>
              <span className="inter-regular-12 text-color-grey-600 ml-1">
                {i18n.t('general.required_field')}
              </span>
            </div>
            <div className="validation_wrapper">
              <div className="form-horizontal">
                <div className="form-group">
                  <div className="e-float-input type-text-input">
                    <label className="label-field-text inter-regular-14">
                      {i18n.t('calendar.title_field')}
                      <span className="inter-semibold-16 text-required ml-1">
                        *
                      </span>
                    </label>
                    <TextBoxComponent
                      id="name"
                      disabled={this.state.disabled}
                      placeholder={i18n.t('calendar.add_title_calendar')}
                      ref={scope => {
                        this.nameObj = scope;
                      }}
                      change={e => {
                        this.setState({ nameValue: e.value });
                      }}
                      input={e => {
                        this.setState({ nameValue: e.value });
                      }}
                      className="field-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="e-float-input">
                    <label className="label-field-text text-color-grey-800 inter-regular-14">
                      {i18n.t('calendar.description')}
                    </label>
                    <TextBoxComponent
                      id="description"
                      row="3"
                      multiline={true}
                      placeholder={i18n.t('calendar.add_description_calendar')}
                      ref={scope => {
                        this.descriptionObj = scope;
                      }}
                      input={() => this.onInput()}
                    />
                    <span id="description-length" />
                  </div>
                  <div id="noError" />
                </div>
                <div></div>
              </div>
              <div>
                {this.props.calendarId !== '' ? (
                  <h4
                    className="e-dlg-header"
                    style={{
                      color: '#001978',
                      fontFamily: 'Inter, Lato, Arial, sans-serif',
                      fontSize: '16px',
                      fontWeight: '600',
                    }}
                  >
                    {i18n.t('calendar.sharewithpeople')}
                  </h4>
                ) : null}
                {this.props.calendarId === '' ? null : this.state
                    .showCalContacts && this.state.showAccessConfig ? (
                  <Acl
                    calendarId={this.state.calendarid}
                    onChangeShareList={this.onChangeShareList}
                    userId={this.props.userId}
                    userNavision={this.props.userNavision}
                    token={this.props.token}
                    userAccount={this.props.userAccount}
                    pw={this.props.userPw}
                    aclData={this.calInvitedPeople}
                    contacts={this.contacts}
                  />
                ) : (
                  <Spinner visible={!this.state.showCalContacts} />
                )}
              </div>
              {this.props.calendarId != '' ? (
                <div className="form-group d-flex align-items-center">
                  <label
                    htmlFor="shareCalendar"
                    style={{ padding: '10px 20px 10px 0' }}
                    className="inter-regular-14 text-color-grey-800"
                  >
                    {i18n.t('calendar.activate_public_link')}
                  </label>
                  <SwitchComponent
                    id="shareCalendar"
                    ref={scope => {
                      this.switch = scope;
                    }}
                    checked={this.state.shareCalendar}
                    change={this.onShareSwitch}
                  />
                </div>
              ) : null}
              {this.state.showCalLink ? (
                <Acl2
                  calendarId={this.state.calendarid}
                  userId={this.props.userId}
                  userAccount={this.props.userAccount}
                  userNavision={this.props.userNavision}
                  pw={this.props.userPw}
                  userName={this.props.userName}
                  userSign={this.props.userSign}
                  aclData={this.calInvitedPeople}
                  calendarData={calendarData}
                />
              ) : null}
              <div className="d-flex justify-content-end btn-action-container mb-4">
                <Button
                  className="btn-outline-primary inter-semibold-14"
                  title={i18n.t('general.cancel')}
                  color="secondary"
                  onClick={() => this.props.cancel()}
                >
                  {i18n.t('general.cancel')}
                </Button>
                <Button
                  disabled={
                    this.state.buttonDisabled || this.state.nameValue === ''
                  }
                  id="modify"
                  className="ml-3 inter-semibold-14"
                  color="primary"
                  title={ObjText}
                  onClick={ObjClick}
                  ref={scope => {
                    this.addBtn = scope;
                  }}
                >
                  {ObjText}
                </Button>
              </div>
              <ToastComponent
                ref={toast => {
                  this.toastObj = toast;
                }}
                id="toast_pos"
                position={this.position}
                target={this.target}
                animation={this.toastCusAnimation}
                timeOut={7000}
                showCloseButton
                open={true}
              ></ToastComponent>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Calendars;
